import React from "react";
import { TableDashboardRow } from "./TableDashboardRow"

export const TableDashboard = props =>
  <div className="box pad-lg">
    <div className="d-flex p-1 align-items-center justify-content-between">
      <h4 className="mb-0">{props.title}</h4>
      <div className="dropdown">
      </div>
    </div>
    <div className="list-item-sm-wrapper">
      {props.values.map(row => <TableDashboardRow
        {...props}
        row={row}
      />)}
    </div >
  </div >
